import React, { useEffect, useState } from 'react';
import { apiFetch } from '../apiFetch';

const PILOT = '3ece9bc70890c09e304cb11510ef8586';
const states = { NO_EXECUTION_CREATED: 'Nenhuma execução criada', ARMED_WAITING_CYCLE: 'Armado, aguardando ciclo',
  FALA_IMPEDIDA: 'Fala impedida', INCERTO: 'Resultado incerto — sem segunda execução',
  PILOT_AUDIBLE_PROTECTED_PASS: 'Reprodução protegida confirmada pelo protocolo',
  ADMITTED: 'Texto admitido', GENERATED: 'Áudio gerado', SENT: 'Tentativa de envio' };
export default function ProtectedPilotExecutionPanel({ clienteId }) {
  const [execution, setExecution] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    setExecution(null); setError('');
    if (clienteId !== PILOT) return undefined;
    let active = true, timer = null, controller = null;
    async function load() {
      controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 10000);
      try {
        const response = await apiFetch(`/api/store-map/${encodeURIComponent(clienteId)}/protected-execution`, { signal: controller.signal });
        const body = await response.json();
        if (!response.ok || body.ok !== true || body.clienteId !== clienteId
          || !body.execution || !Object.hasOwn(states, body.execution.state)) throw new Error('Não foi possível confirmar a execução.');
        if (active && !controller.signal.aborted) { setExecution(body.execution); setError(''); }
      } catch (err) { if (active) setError('Leitura não confirmada. O último estado abaixo pode estar desatualizado.'); }
      finally { clearTimeout(timeout); if (active) timer = setTimeout(load, 2500); }
    }
    load();
    return () => { active = false; clearTimeout(timer); controller?.abort(); };
  }, [clienteId]);
  if (clienteId !== PILOT) return null;
  return <section style={{ border: '1px solid var(--border)', padding: 16, marginBottom: 14 }}>
    <h2 style={{ fontSize: 15 }}>Canário único anterior — execução registrada</h2>
    {error && <p role="alert">{error}</p>}
    <p>{execution ? states[execution.state] : 'Carregando execução…'}</p>
    {execution?.deliveryId && <>
      <p>Execução: {execution.deliveryId}</p>
      <p>Texto preparado: {execution.text || 'Ainda não preparado'}</p>
      <p>Hash do texto: {execution.textHash || 'ausente'}</p>
      <p>Admissão: {execution.admission || 'não realizada'}{execution.vetoes?.length ? ` — ${execution.vetoes.join(', ')}` : ''}</p>
      {execution.reason && <p>Motivo registrado: {execution.reason}</p>}
      <p>Fontes: {execution.sourceRefs?.join(', ') || 'não selecionadas'} — revisão {execution.sourceRevision || 'ausente'}</p>
      <p>Áudio: {execution.audioState === 'GENERATED' ? 'Gerado' : 'Não gerado'}; hash {execution.audioSha256 || 'ausente'}</p>
      <p>Transporte: {execution.transport === 'ACK' ? 'ACK do player' : execution.transport === 'SENT' ? 'Tentativa de envio' : 'Não enviado'}</p>
      <p>Exposição: {execution.exposure === 'LOCUTOR_ENDED' ? 'LOCUTOR_ENDED da mesma execução' : 'Não confirmada'}</p>
      <p>TTS: {execution.ttsCalls || 0}; tentativas de envio: {execution.sendAttempts || 0}.</p>
      <p>Texto preparado e admissão não são confirmação de reprodução.</p>
    </>}
  </section>;
}
